module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 23.95 25"
    }
  }, [_c('defs'), _c('g', {
    attrs: {
      "id": "Слой_2",
      "data-name": "Слой 2"
    }
  }, [_c('g', {
    attrs: {
      "id": "Слой_1-2",
      "data-name": "Слой 1"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M0,12.52V2.09A1.86,1.86,0,0,1,2.06,0C3.51,0,3.51,0,3.51,1.45V7.37c0,1.24.49,1.72,1.72,1.72H15.1c1.24,0,1.71-.47,1.71-1.71,0-2.24,0-4.48,0-6.72,0-.46.08-.62.59-.65A2.23,2.23,0,0,1,19.33.8c1.38,1.47,2.83,2.87,4.27,4.28a1.08,1.08,0,0,1,.35.86c0,5.68,0,11.35,0,17a1.84,1.84,0,0,1-2,2H2a1.84,1.84,0,0,1-2-2Zm12,9.6h6.85c1.15,0,1.66-.51,1.66-1.65q0-3.6,0-7.2c0-1.16-.46-1.62-1.59-1.63q-3.36,0-6.7-.05c-2.34,0-4.68,0-7,0-1.21,0-1.72.52-1.72,1.73q0,3.51,0,7c0,1.21.51,1.72,1.72,1.73Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M10.22,0h3.21c.69,0,1,.28,1,1,0,1.64,0,3.28,0,4.93,0,.65-.29.95-.95.95-2.18,0-4.35,0-6.53,0-.67,0-.94-.28-.94-.95C6,4.28,6,2.61,6,1,6,.29,6.28,0,7,0Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M12,19.65H6.35c-.72,0-1.17-.48-1-1.06a.84.84,0,0,1,.87-.64c3.84,0,7.68,0,11.51,0a.85.85,0,0,1,.91.87.86.86,0,0,1-1,.83Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M12,16.12H6.42c-.71,0-1.09-.3-1.12-.86s.42-.87,1.07-.87c1.17,0,2.34,0,3.51,0,1.66,0,3.32,0,5,0,.84,0,1.68,0,2.52,0a1.39,1.39,0,0,1,.6.08.81.81,0,0,1,.64.92.8.8,0,0,1-.85.74H12Z"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a231e5b0","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIconNew/templates/icons/save.vue
// module id = fa951ee0b4d03e8206f2
// module chunks = 89